import type { AvailableIntegrationsQuery } from 'generated/resources/graphql'
import {
  AvailableIntegrationsDocument,
  IntegrationsCapabilityModeEnum,
  IntegrationsSyncRunOriginEnum,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type MarketplaceDbIntegration =
  AvailableIntegrationsQuery['integrations']['availableIntegrationsConnection']['nodes'][number]['marketplaceIntegration']

export interface AvailableIntegrationViewModel {
  capabilityMode: IntegrationsCapabilityModeEnum
  marketplaceIntegration: MarketplaceDbIntegration
}

export const useAvailableIntegration = (
  origin: IntegrationsSyncRunOriginEnum
): AvailableIntegrationViewModel | null => {
  const { data } = useQuery(AvailableIntegrationsDocument, {
    variables: {
      origin,
    },
  })

  const node = data?.integrations?.availableIntegrationsConnection.nodes[0]

  if (!node) return null

  return {
    capabilityMode: node.capabilityMode,
    marketplaceIntegration: node.marketplaceIntegration,
  }
}
